jQuery(function($){
  
  
    
  jQuery('.site-nav > li').each(function(){
    if($(this).find('.mega-menu_grid')){
    	$(this).addClass('mega-menu');
      	$(this).find('.site-nav__dropdown').addClass('mega-menu-wrapper');
    }
  });
  
  setTimeout(function(){
    jQuery('.site-header .desktop_nav .site-nav').css({'visibility': 'visible'});
  },1000);
  
  jQuery('.tabs-header li a').click(function(e){
    e.preventDefault();
    var parent_id = jQuery(this).parents('ul').find('li').removeClass('active');
    jQuery(this).parent('li').addClass('active');
  	var tab_id = jQuery(this).attr('href');
    jQuery(tab_id).show().siblings().hide();
    jQuery(tab_id).find('.tab-carousel').slick('refresh');
    return false;
  });
  
  jQuery('.catering-grid a').click(function(e){
    e.preventDefault();
    var parent_id = jQuery(this).parents('.catering-grid').find('.grid__item').removeClass('active');
    jQuery(this).parents('.grid__item').addClass('active');
  	var tab_id = jQuery(this).attr('href');
    jQuery(tab_id).show().siblings().hide();
    if($(window).width() <= 766){
    	$('html, body').animate({
          scrollTop: $(tab_id).offset().top - 10
      }, 500);
    }
    return false;
  });
  
  jQuery('.form-btn-scroll-wrapper a').click(function(e){
    e.preventDefault();
    var tab_id = jQuery(this).attr('href');
  	 $('html, body').animate({
          scrollTop: $(tab_id).offset().top
      }, 500);
    return false;
  });
  
 
if($('.tab-container .tab-carousel').length > 0 || $('.product-single__related').length > 0){  
$('.tab-container .tab-carousel').slick({
  dots: false,
  infinite: true,
  speed: 300,
    arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 340,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  
 
  $(window).on('load resize', function(){
    $('#page-loader').fadeOut();
    setTimeout(function(){
  if($(window).width() <= 765){  
     $('.catering-grid').slick({  
          variableWidth: true,
          dots: false,
          infinite: false,
          arrows:false
     }); 
    }
      
      },1000); 
  });

  $(window).on('resize load', function(){
   /* if($(window).width() <= 1000){ 
      $('.collactions-tabs-title-tabs .tabs-header ul').slick({
        variableWidth: true,
        dots: false,
        infinite: false,
        arrows:false
      });
    } */
  });   
}

  setTimeout(function(){
  jQuery('.tab-container.hide-gallery, body .hide-onload').hide();
 },1000);
 
  $(document).on('click','body .site-header .js-drawer-open-cart',function(e){
    
    console.log('here');
    e.preventDefault();
    setTimeout(function(){
      var html = $('.form_html').html();
      var cart_html = $('#calendar-wrapper').html();
      if(cart_html == ''){
        $('#calendar-wrapper').html(html);
      }

    },2000);
  });
  
   $('.logo-bar').slick({
  dots: false,
  infinite: true,
  speed: 300,
    arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 340,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  
  $('.instagram-feed-wrap .feed-inner-wrapper').slick({
  dots: false,
  infinite: true,
  speed: 300,
    arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 340,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  
  /*
  $('.flavour-filter input').on('change', function(){
    var values = [].filter.call(document.getElementsByName('filter[]'), function(c) {
      return c.checked;
    }).map(function(c) {
      return c.value;
    });
    
    console.log(values);
    
  });
  */
  
  jQuery('.accordion-section .section-header').click(function(){
  	jQuery(this).parents('.accordion-section').find('.grid.grid--flush-bottom').slideToggle();
  });
  if(jQuery('.accordion-child-section').length > 0){
    jQuery('.accordion-child-section').each(function(){
    	var section_id = jQuery(this).attr('data-id');
      	jQuery(section_id).append(jQuery(this).html());
        jQuery(this).remove();
    });
  }
  
  setTimeout(function(){
    $('.site-navigation').css({'opacity': '1'});
  }, 2000);
  
  
  $(window).on('load', function(){
    if($(window).width() >= 768){
      $('[data-bg]').each(function(){
        var img_url = '';
      	img_url = $(this).attr('data-bg');
        $(this).css({"background-image": "url('"+img_url+"')"});
        console.log(img_url);
      });
    }else{
      $('[data-bg]').each(function(){
        var img_mobile_url = '';
        var img_url = '';
        img_mobile_url = $(this).attr('data-mobile-bg');
        img_url = $(this).attr('data-bg');
        if(img_mobile_url !== null && img_mobile_url !== '' && img_mobile_url !== undefined ){
          $(this).css({"background-image": "url('"+img_mobile_url+"')"});
        }else{
          $(this).css({"background-image": "url('"+img_url+"')"});
        }
      });
    }
  });
  
});

function menu_toggle($hide, $show, $element){
	$('.'+$hide).hide();
  $('.'+$show).css({'display': 'flex'});
  
  if( $element == ''){
  	console.log('empty');
  }else{
    console.log($('#'+$element).find('.drawer__close-button').length);
  	jQuery('#'+$element).find('.drawer__close-button').trigger('click');
  }
}




